import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M26.162 9.35a.5.5 0 0 1 .666.588l-3.801 15.205a.5.5 0 0 1-.839.233l-4.412-4.413a.5.5 0 0 1-.075-.61l2.033-3.389c.263-.438-.223-.941-.67-.695l-3.707 2.042a.5.5 0 0 0-.046.848l1.765 1.232a.5.5 0 0 1 .114.71l-2.305 3.073a.5.5 0 0 1-.874-.142l-1.758-5.273a.5.5 0 0 0-.25-.29l-3.057-1.527a.5.5 0 0 1 .043-.913L26.162 9.35Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgTelegram;